import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { PageBlock, Stack } from '@etg/wings';
import { useProperty } from '@eti/providers';
import { BoundNew } from '@eti/types';
import HotelsAndRentalCarsModal from './modals/HotelsAndRentalCarsModal';
import BookingComWidget from './BookingComWidget';
import CarTrawlerWidget from './CarTrawlerWidget';
import HotelsComWidget from './HotelsComWidget';
import RentalCarsWidget from './RentalCarsWidget';

const UpsellWidget = ({
  bounds,
  locale,
  nationalityId,
  obfuscatedOrderNumber,
  purchaseDate,
  travelers,
}) => {
  const { p } = useProperty();
  const [showModal, setShowModal] = useState(false);

  const s = p('Order.HotelAndCarModal.DisplayAfterSeconds') || 0;
  const ms = s * 1000;

  useEffect(() => {
    setTimeout(() => setShowModal(true), ms);
  }, [ms]);

  const hotelsComEnabled = p('IbeClient.Order.UpsellHotelsCom.Enable');
  const bookingComEnabled = p('IbeClient.Order.UpsellBookingCOM.Enable');
  const rentalCarsEnabled = p('IbeClient.Order.UpsellRentalCars.Enable');
  const carTrawlerEnabled = p('IbeClient.Order.UpsellCarTrawler.Enabled');

  return (
    <>
      {p('Order.HotelAndCarModal.Enabled') && showModal && (
        <HotelsAndRentalCarsModal bounds={bounds} travelers={travelers} />
      )}
      {(hotelsComEnabled || bookingComEnabled) && (
        <PageBlock as="section" withPaddingY>
          <Stack>
            {hotelsComEnabled && (
              <HotelsComWidget
                bounds={bounds}
                locale={locale}
                obfuscatedOrderNumber={obfuscatedOrderNumber}
                purchaseDate={purchaseDate}
                travelers={travelers}
              />
            )}
            {bookingComEnabled && <BookingComWidget bounds={bounds} />}
          </Stack>
        </PageBlock>
      )}
      {(rentalCarsEnabled || carTrawlerEnabled) && (
        <PageBlock as="section" withPaddingY>
          <Stack>
            {rentalCarsEnabled && (
              <RentalCarsWidget
                bounds={bounds}
                locale={locale}
                obfuscatedOrderNumber={obfuscatedOrderNumber}
                purchaseDate={purchaseDate}
                travelers={travelers}
              />
            )}
            {carTrawlerEnabled && (
              <CarTrawlerWidget bounds={bounds} nationalityId={nationalityId} />
            )}
          </Stack>
        </PageBlock>
      )}
    </>
  );
};

UpsellWidget.propTypes = {
  bounds: PropTypes.arrayOf(BoundNew),
  locale: PropTypes.string,
  nationalityId: PropTypes.string,
  obfuscatedOrderNumber: PropTypes.string,
  purchaseDate: PropTypes.string,
  travelers: PropTypes.arrayOf(
    PropTypes.shape({
      ageType: PropTypes.string,
      birthDate: PropTypes.string,
      firstName: PropTypes.string,
      gender: PropTypes.string,
      id: PropTypes.string,
      lastName: PropTypes.string,
      name: PropTypes.string,
      passportNumber: PropTypes.string,
      products: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          quantity: PropTypes.number,
        }),
      ),
    }),
  ),
};

export default UpsellWidget;
